// src/quiz/gre-mock2/index.js
// GRE Mock 2 — props for the shared Gre_verbal / Gre_quantitative /
// Gre_analytical components. Test names end in "Mock 2" so the profile
// keeps these results apart from Mock 1 ("GRE Verbal Reasoning", ...).
import verbalQuestions from "./verbalData";
import { section1Questions, section2Questions } from "./quantitativeData";

export const greMock2 = {
  verbal: {
    questions: verbalQuestions,
    testName: "GRE Verbal Reasoning Mock 2",
    title: "GRE Verbal Reasoning — Mock 2",
  },
  quantitative: {
    section1: section1Questions,
    section2: section2Questions,
    testName: "GRE Quantitative Reasoning Mock 2",
    title: "GRE Quantitative Reasoning — Mock 2",
  },
  analytical: {
    testName: "GRE Analytical Writing Mock 2",
    title: "GRE Analytical — Mock 2",
    prompt:
      "\"The true measure of a technological advance is not how impressive it is but how broadly it improves the lives of ordinary people.\"",
    directions:
      "Write a response in which you discuss the extent to which you agree or disagree with the statement and explain your reasoning for the position you take. In developing and supporting your position, you should consider ways in which the statement might or might not hold true and explain how these considerations shape your position.",
    topicKeywords: [
      "technolog", "advance", "innovat", "invent", "progress", "ordinary",
      "people", "improv", "benefit", "access", "impress", "measure",
    ],
  },
};
